import { useEffect, useRef } from "react";

import { Markdown } from "../mind/markdown";
import { clock, threadOf } from "./thread";
import type { CogentLive } from "./chat-view";
import { MessageViews } from "./message-views";

import s from "../cogent.module.css";

type ThreadMessage = Extract<
  ReturnType<typeof threadOf>[number],
  {
    kind: "message";
  }
>;

export function ChatMessage({
  item,
  live,
}: {
  item: ThreadMessage;
  live: CogentLive;
}) {
  const retry = live.retry;
  const { message } = item;
  const element = useRef<HTMLDivElement>(null);
  // Recheck when a retained transcript becomes visible; the request recorder deduplicates milestones.
  useEffect(() => {
    if (
      message.from === "cogent" &&
      message.text.trim() &&
      element.current?.checkVisibility()
    )
      live.recordAssistantCommit?.(message.id);
  });
  return (
    <div
      ref={element}
      className={s.msg}
      data-from={message.from}
      data-first={item.first ? "" : undefined}
      data-pending={message.pending}
      title={
        message.at
          ? clock({
              at: message.at,
            })
          : undefined
      }
    >
      {message.from === "cogent" ? (
        <Markdown text={message.text} />
      ) : (
        <p>{message.text}</p>
      )}
      <MessageViews message={message} live={live} />
      {message.pending === "sending" || message.pending === "waiting" ? (
        <p className={s.queued}>Queued</p>
      ) : null}
      {message.pending === "failed" ? (
        <p className={s.unsent} role="alert">
          Not sent.{" "}
          <button
            type="button"
            className={s.link}
            onClick={() => retry(message.id)}
          >
            Retry
          </button>
        </p>
      ) : null}
    </div>
  );
}
